<template>
  <div class="ma-md-4">
    <!-- <div class="text-h4 my-4">Calculators &amp; Utilities</div> -->
    <div class="d-flex flex-row flex-wrap">
      <v-card
        v-for="(item, index) in items"
        :key="index"
        hover
        class="ma-4"
        width="350"
        @click="goTo(item)"
      >
        <div class="d-flex flex-row align-start header">
          <div class="imageCol">
            <v-img
              :src="path.image + item.image"
              max-width="60"
              contain
              class="mx-auto mt-1"
            ></v-img>
          </div>
          <div>
            <div class="text-h6 mx-2 mt-2">{{ item.name }}</div>
            <div
              v-if="item.pro && !isSubscribed"
              class="red--text mx-2 my-1 caption"
            >
              Pro Feature
            </div>
          </div>
        </div>
        <!-- <v-divider class="mt-1"></v-divider> -->

        <v-card-text><span v-html="item.description"></span></v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
// import calcsMenuOptions from "@/assets/js/calcs/calcsMenuOptions";
import UserMixin from "@/assets/js/UserMixin";

export default {
  name: "calcsHome",
  props: { items: null },
  mixins: [UserMixin],
  data: function () {
    return {
      path: {
        image: "https://www.eyedock.com/images/menu_icons",
        calcs: "https://www.eyedock.com/calcs",
      },
    };
  },
  methods: {
    goTo(obj) {
      // console.log(obj);
      if (obj.calcUrl) {
        window.location.href = this.path.calcs + obj.calcUrl;
      } else if (obj.path) {
        this.$router.push({ path: obj.path }).catch(() => {});
      } else if (obj.url) {
        window.location.href = obj.url;
      }
    },
  },

  computed: {
    // items: function () {
    //   return calcsMenuOptions.calcsMenuOptions;
    // },
  },
};
</script>

<style scoped>
.imageCol {
  width: 90px;
}
.header {
  min-height: 75px;
  background-color: #f3f8fa;
  border-bottom: 1px solid #e5ebed;
}
</style>
